import $ from 'jquery'

$(document).on('turbolinks:load', function() {
  $('.carousel').carousel()
})
